/* eslint-disable */
import "@fr/pages/desktop/travelata/travelata/atlas/search.js"

import "./style/operatorHeaders.scss"
import "./style/operatorPage-search.scss"